import type { Vector3 } from "three/webgpu";
import type { PresentedNode } from "../../presentation/mesh";
import type { FocusState } from "../../store/nexusStore";
import type { CameraFrame } from "./CameraFramingPolicy";

export function resolveWorldFocusFrame(
  focus: FocusState,
  node: PresentedNode | null,
  origin: Vector3 | null,
  relatedPositions: Iterable<Vector3>,
): CameraFrame {
  if (focus.kind === "cosmos") return { mode: "cosmos", radius: 1 };
  if (focus.kind === "orbital") return { mode: "orbital-follow", radius: 1.6 };
  if (!node) return { mode: "inspection", radius: 1.4 };
  if (node.archetype === "black-hole") return { mode: "singularity", radius: 6.4 };
  if (node.kind !== "system" || !origin) return { mode: "inspection", radius: 1.8 };

  let radius = 2.4;
  for (const position of relatedPositions) radius = Math.max(radius, origin.distanceTo(position));
  return { mode: "architecture", radius: Math.min(radius, 5.2) };
}
